<div class="title-bar title-bar-shadow" [ngClass]="{ draggable: isDraggable }">
    <div class="title-bar-title">
        <p-icon-image name="ai-seemore-launcher" size="lg"></p-icon-image>
        {{ 'aichat.chat.title' | translate }}
    </div>
    <div class="title-bar-icons">
        <p-action-button
            class="title-bar-button"
            (buttonClicked)="reset()"
            [disabled]="isAssistantWorking"
            iconBeforeName="ai-clear-chat"
            [matTooltip]="'aichat.chat.clear_chat' | translate"
        >
        </p-action-button>
        <!-- TODO: temp — replace with p-picker-single-select once picker is migrated to publishable -->
        <div class="layout-picker-wrapper" (click)="toggleLayoutMenu($event)">
            <p-action-button
                class="title-bar-button"
                iconBeforeName="open-side-panel"
                [matTooltip]="'aichat.chat.layout' | translate"
            ></p-action-button>
            <div class="layout-picker-panel" *ngIf="isLayoutMenuOpen$ | async">
                <div class="layout-picker-body">
                    <button
                        *ngFor="let option of (layoutOptions$ | async) ?? []"
                        class="layout-picker-item"
                        [class.layout-picker-item--selected]="option.id === currentLayout"
                        [attr.automation-id]="'ai-chat-layout-' + option.id"
                        (click)="selectLayout(option.id); $event.stopPropagation()"
                    >
                        <p-icon class="layout-picker-item-icon" [name]="option.icon"></p-icon>
                        <span>{{ option.name }}</span>
                    </button>
                </div>
            </div>
        </div>
        <!-- /TODO: temp -->
        <p-action-button class="title-bar-button" (buttonClicked)="close()" iconBeforeName="x"></p-action-button>
    </div>
</div>
